"use strict";
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="e662d4ed-d8c3-577f-9a8c-26d908a4ffa8")}catch(e){}}();

Object.defineProperty(exports, "__esModule", { value: true });
exports.QzPermission = exports.Currency = exports.Country = exports.UserRole = void 0;
var UserRole;
(function (UserRole) {
    UserRole["MANAGER"] = "manager";
    UserRole["BUSINESS_MANAGER"] = "business manager";
    UserRole["ARTIST"] = "artist";
    UserRole["BOOKING_AGENT"] = "booking agent";
    UserRole["SYNC_AGENT"] = "sync agent";
    UserRole["ACCOUNTANT"] = "accountant";
    UserRole["LAWYER"] = "lawyer";
    UserRole["ADMIN"] = "admin";
})(UserRole || (exports.UserRole = UserRole = {}));
var Country;
(function (Country) {
    Country["UNITED_STATES"] = "United States";
    Country["CANADA"] = "Canada";
    Country["MEXICO"] = "Mexico";
})(Country || (exports.Country = Country = {}));
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
    Currency["MXN"] = "MXN";
})(Currency || (exports.Currency = Currency = {}));
var QzPermission;
(function (QzPermission) {
    QzPermission["READ_ACCOUNTING"] = "read_accounting";
    QzPermission["READ_BANK"] = "read_bank";
    QzPermission["READ_TEAM"] = "read_team";
    QzPermission["READ_RUN"] = "read_run";
    QzPermission["EDIT_ACCOUNTING"] = "edit_accounting";
    QzPermission["EDIT_BANK"] = "edit_bank";
    QzPermission["EDIT_TEAM"] = "edit_team";
    QzPermission["EDIT_RUN"] = "edit_run";
    QzPermission["DELETE_ACCOUNTING"] = "delete_accounting";
    QzPermission["DELETE_BANK"] = "delete_bank";
    QzPermission["DELETE_TEAM"] = "delete_team";
    QzPermission["DELETE_RUN"] = "delete_run";
    QzPermission["OWN_ACCOUNTING"] = "own_accounting";
    QzPermission["OWN_BANK"] = "own_bank";
    QzPermission["OWN_TEAM"] = "own_team";
    QzPermission["OWN_RUN"] = "own_run";
    QzPermission["TAG_ACCOUNTING"] = "tag_accounting";
    QzPermission["BLURRYFACE"] = "blurryface";
})(QzPermission || (exports.QzPermission = QzPermission = {}));
//# sourceMappingURL=user.js.map
//# debugId=e662d4ed-d8c3-577f-9a8c-26d908a4ffa8
